import {
  Col,
  Card,
  Form,
  Button,
  Input,
  CardBody, Row,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { Tooltip } from "@mui/material";
import { useState, useEffect, useRef } from 'react';
import Datetime from 'react-datetime';
import search from "../../../assets/images/search.png";
import 'react-datetime/css/react-datetime.css';
import DisbursementModal from '../../DisbursementModal/DisbursementModal';
import { useNavigate } from 'react-router-dom';
import MoveDisbursementStatus from '../MoveDisbursementStatus/MoveDisbursementStatus';
import statusimage from "../../../assets/images/status.png";
import rightarrow from "../../../assets/images/chevron-right.png";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import "./ReadyToDisburse.css";
import download from "../../../assets/images/download.png";
import selfie from "../../../assets/images/camera.png";
import kyc from "../../../assets/images/kyc1.png";
import agreement from "../../../assets/images/agreement.png";
import mandate from "../../../assets/images/mandate1.png";
import fraudimage from "../../../assets/images/fraudimage.png";
import PaginationTable from '../PaginationTable';
import axiosInstance from '../../../helpers/axios';
import { handleExcelDownload } from '../../../utils/excelDownload';
import { useSelector, useDispatch } from "react-redux";
import RefreshIcon from '@mui/icons-material/Refresh';
import { userActions } from '../../../actions/user.actions';
import InstituteAutocomplete from '../../status/ProjectTable/InstituteSearch';
import { Accordion, AccordionSummary, } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { IconButton } from '@mui/material';
import { styled } from "@mui/material/styles";
import IntegrationModals from '../../IntegrationModals/IntegrationModals';
import { ApplicationStatusEnum } from '../../../data';
import * as moment from "moment";
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { appContextConstants } from '../../../constants/appContext.constants';
import SourceBadge from "../../shared/SourceBadge/SourceBadge";
const CustomAccordionSummary = styled(AccordionSummary)({
  minHeight:50,
  "&.Mui-expanded": {
    minHeight: 40, 
  },
  cursor: "default !important", 
  "& .MuiAccordionSummary-content": {
    margin: "0px !important",
    alignItems: "center",
    
  },
});


const CustomAccordion = styled(Accordion)(({ theme }) => ({
  margin: 0, 
  "&:before": {
    display: "none", 
  },
}));


//import '../../assets/scss/_variables.scss';

// eslint-disable-next-line import/extensions
//import ComponentCard from '../ComponentCard';

require('moment/locale/fr');
require('moment/locale/de');
require('moment/locale/en-gb');

const FILTER_KEY = "readyToDisburseFilters";
const getSavedFilters = () => {
  try {
    return JSON.parse(sessionStorage.getItem(FILTER_KEY) || "null") || {};
  } catch {
    return {};
  }
};


const InDisbursement = () => {
  const productTypeSelected = useSelector(
    (state) => state.ProductTypeFilter.selectedProductType
  );
 const saved = getSavedFilters();
  const state = useSelector((state) => state?.Readytodisburse?.res);
  const datestate = useSelector((state) => state.Datefilter?.res);
  const { appId: ctxAppId } = useSelector((state) => state.appContext);
  // const state = useMemo(() => (res), []);


  const dispatch = useDispatch();
  const modalRef = useRef();

  //tooltip



  const status = ApplicationStatusEnum.ReadyToDisburse
  const decode = useCurrentUser();
  const user = null;
  //filter
  const [filterDateFrom, setFilterDateFrom] = useState(saved.filterDateFrom||null);
  const [filterDateTo, setFilterDateTo] = useState(saved.filterDateTo||null);
  const [isLoading, setIsLoading] = useState(true);
  const [advChecked,setAdvChecked] = useState(true)
  const [pfsChecked,setPfsChecked] = useState(true)
  const [totalAmountToBeDisbursed,setTotalAmountToBeDisbursed] = useState(null)
  const [id,setId]=useState(saved.instituteId||null)
  const [instituteName, setInstituteName] = useState(saved.instituteName || '');
  const [instituteResetKey, setInstituteResetKey] = useState(0);


  const valid = (current) => {
    return current.isAfter(filterDateFrom);
  };
//tooltip
 const [clicked,setClicked] = useState(false)
 const [activePage, setActivePage] = useState(15); 
 const [expanded, setExpanded] = useState(false);
 
  //table
  const [tableData, setTableData] = useState([]);
 
  // eslint-disable-next-line no-unneeded-ternary
  const [currentPage, setcurrentPage] = useState(sessionStorage.getItem("page") ? parseInt(sessionStorage.getItem("page")) : 1);
  //pagination
  //changepage

  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [totalFetchRows, setTotalFetchRows] = useState(null);
  const usersearchstate = useSelector((state) => state?.UserSearch?.res?.data?.data);
    //sorting


  const urlUsers = `/integrations/applications?status=${status}&perPage=${rowsPerPage}&pageNo=${currentPage}&sortOrder=${-1}`;

  const refreshTableData = () => {
    axiosInstance.get(urlUsers, {
    }).then((resp) => {
      setTableData(resp.data.data.details);
      setcurrentPage(resp.data.data.pagination.currentPage);
      setTotalFetchRows(resp.data.data.pagination.totalRows);
      setrowsPerPage(resp.data.data.pagination.perPage);
    });
  };

  const clearDateFilter =()=>{
    setClicked(false)
    setFilterDateFrom(null)
    setFilterDateTo(null)
    setId(null);
    setInstituteName('');
    setcurrentPage(1);
    setActivePage(15);
    setInstituteResetKey((prev) => prev + 1);
    const urlUsers = `/integrations/applications?status=${status}&perPage=${rowsPerPage}&pageNo=${currentPage}&sortOrder=${-1}`;
    
        axiosInstance.get(urlUsers, {
          headers: {
          },
        })
        .then((res) => {
         
          setTableData(res?.data?.data?.details);
          setcurrentPage(res?.data?.data?.pagination?.currentPage);
          setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
          setrowsPerPage(res?.data?.data?.pagination?.perPage);  
       
        })
        .catch((error) => {
          alert(error?.response?.data?.message)
          console.error("Error fetching filtered data:", error);
        });
      }

      useEffect(() => {
    sessionStorage.setItem(
      FILTER_KEY,
      JSON.stringify({
        filterDateFrom,
        filterDateTo,
        instituteId: id,
        instituteName,
      })
    );
  }, [filterDateFrom, filterDateTo, id, instituteName]);
  useEffect(() => { window.addEventListener("beforeunload", () => sessionStorage.removeItem("readyToDisburseFilters")); }, []);

  useEffect(() => {
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { status } });
    if(usersearchstate){
      setIsLoading(false);
      setTableData(usersearchstate?.details);
      setcurrentPage(usersearchstate?.pagination?.currentPage);
      setTotalFetchRows(usersearchstate?.pagination?.totalRows);
      setrowsPerPage(usersearchstate?.pagination?.perPage);
    }
else{
 

  if(datestate){
    setTableData(datestate?.details);
    setcurrentPage(datestate?.pagination.currentPage);
    setTotalFetchRows(datestate?.pagination.totalRows);
    setrowsPerPage(datestate?.pagination.perPage); 
  }
  else{
    
      let queryParams = {}
    
      if(filterDateFrom && filterDateTo){
        queryParams.fromDate = filterDateFrom;
        queryParams.toDate = filterDateTo+" 23:59:59"
      }
      
      if(id){
        queryParams.instituteId = id
      }
     
      if(status){
        queryParams.status = status
      }
    
     
      if(rowsPerPage && currentPage){
        queryParams.perPage = rowsPerPage;
        queryParams.pageNo = 1
      }

    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.productType = Number(productTypeSelected);
    }
      axiosInstance.get('/integrations/applications',{
        params:queryParams,
        headers: {
        },
      })
      .then((res)=>{
        setTableData(res?.data?.data?.details);
        const amount = res?.data?.data?.details?.map((item) => (item?.amountToBeDisbursed -
                    ((item?.advanceEmiStatus === 1) ? (item?.advanceEmiAmount || 0) : 0) -
                    ((item?.processingFeeStatus === 1) ? (item?.processingFees || 0) : 0)));
        const totalAmount = amount?.reduce((sum, current) => sum + (current || 0), 0);
        setTotalAmountToBeDisbursed(totalAmount)
        setcurrentPage(res?.data?.data?.pagination?.currentPage);
        setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
        setrowsPerPage(res?.data?.data?.pagination?.perPage);
          setIsLoading(false);
      })
      .catch((error) => error)



  }
}

  }, [datestate, state, usersearchstate, productTypeSelected]);
  const paginate = (pageNumber) => {
setcurrentPage(pageNumber)
    let queryParams = {}
    
      if(filterDateFrom && filterDateTo){
        queryParams.fromDate = filterDateFrom;
        queryParams.toDate = filterDateTo+" 23:59:59"
      }
      
      if(id){
        queryParams.instituteId = id
      }
     
      if(status){
        queryParams.status = status
      }
    
     
      if(rowsPerPage && currentPage){
        queryParams.perPage = rowsPerPage;
        queryParams.pageNo = pageNumber
      }

    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.productType = Number(productTypeSelected);
    }
      axiosInstance.get('/integrations/applications',{
        params:queryParams,
        headers: {
        },
      })
      .then((res)=>{
        setTableData(res?.data?.data?.details);
        const amount = res?.data?.data?.details?.map((item) => (item?.amountToBeDisbursed -
                    ((item?.advanceEmiStatus === 1) ? (item?.advanceEmiAmount || 0) : 0) -
                    ((item?.processingFeeStatus === 1) ? (item?.processingFees || 0) : 0)));
        const totalAmount = amount?.reduce((sum, current) => sum + (current || 0), 0);
        setTotalAmountToBeDisbursed(totalAmount)
        setcurrentPage(res?.data?.data?.pagination?.currentPage);
        setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
        setrowsPerPage(res?.data?.data?.pagination?.perPage);
          setIsLoading(false);
      })
      .catch((error) => error)

  };

  //datefilter
  const handleDateFilterApi = (startDate, endDate) => {
    setClicked(!clicked)
    setFilterDateFrom(startDate)
    setFilterDateTo(endDate)
   
      let queryParams = {}
    
    if(startDate && endDate){
      queryParams.fromDate = startDate;
      queryParams.toDate = endDate+" 23:59:59"
    }
    
    if(id){
      queryParams.instituteId = id
    }
   
    if(status){
      queryParams.status = status
    }
  
   
    if(rowsPerPage && currentPage){
      queryParams.perPage = rowsPerPage;
      queryParams.pageNo = 1
    }

    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.productType = Number(productTypeSelected);
    }
    axiosInstance.get('/integrations/applications',{
      params:queryParams,
      headers: {
      },
    })
    .then((res)=>{    
      setTableData(res?.data?.data?.details);
      setcurrentPage(res?.data?.data?.pagination?.currentPage);
      setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
      setrowsPerPage(res?.data?.data?.pagination?.perPage);
      setIsLoading(false);
    })
    .catch((error) => error)

  };


  const navigate = useNavigate();

  const handleUser = (event) => {
    const Id = event.userId;
    const applId = event.applicationId
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: {
      selectedUserId: event.userId,
      userId: event.userId,
      coapplicantId: event?.coapplicantId ? (typeof event?.coapplicantId == "string") ? event?.coapplicantId : event?.coapplicantId[0] : "",
      appId: applId,
    }});
//     const urlProfile = `/summary/user?id=${Id}&applicationId=${event.applicationId}&status=Ready to Disburse`;

//     dispatch(userActions.fetchHandleuser(urlProfile, user),[])
//       const ckycUrl=`/ckyc/details?userId=${Id}`;
//   const digilockerUrl=`/digilocker/details?applicationId=${event.applicationId}&userId=${Id}`;
//   const panUrl=`/application/pan-details?userId=${Id}&applicationId=${event.applicationId}`;
//   const bankSelfieUrl=`/integrations/details?applicationId=${event.applicationId}&userId=${Id}`;
//   const uploadedFileUrl=`/users/documents/admin?userId=${Id}`
  const getActivityUrl=`/audit?applicationId=${event.applicationId}`
// const urlForBankSelfie=`/integrations/application-profile?applicationId=${event.applicationId}`
//   //cibil
//   const urlCIBIL = `/cibil/report?userId=${Id}`

//   const urlIncomeProfile=`/bank-statement-analysis/finbox/admin-analytics-data/all?userId=${Id}&applicationId=${event.applicationId}`
   
//     dispatch(userActions.getIncomeProfileAnalytics(urlIncomeProfile,user))
//     const getFoirRefUrl=`/admin/application/additional-info?applicationId=${event.applicationId}`
//   dispatch(userActions.getFoirDetails(getFoirRefUrl,user));
//         dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie,user),[])
   
  
//      dispatch(userActions.getCkycDetails(ckycUrl,user));
//     dispatch(userActions.getCibilDetails(urlCIBIL));
//     dispatch(userActions.getPanStatus(panUrl));
//     dispatch(userActions.getBankSelfieDetails(bankSelfieUrl,user));
//     dispatch(userActions.getDigiLocker(digilockerUrl,user));
//     dispatch(userActions.getProfileDetails(urlProfile));
//     dispatch(userActions.getUploadedFiles(uploadedFileUrl,user));
    dispatch(userActions.getActivity(getActivityUrl,user));
    navigate('/status/disbursement/profile', {
      state: { id: 1, profileId: Id,applicantId:Id,coapplicantId:event.coapplicantId,applicationId:event.applicationId,dir:"Ready to Disburse", coapplicants: event?.coapplicants, name: event?.name },
    });

   
  };

 


  const handleCoApp = (event,currTab) => {
    
    const Id = event?.coapplicantId ? (typeof event?.coapplicantId == "string")?event?.coapplicantId:event?.coapplicantId[0]:"";

//     const urlProfile = `/summary/coapplicant?id=${Id}&status=In Disbursement`;
   
//     dispatch(userActions.fetchHandlcoappuser(urlProfile, user),[])

//       const ckycUrl=`/ckyc/details?userId=${Id}`;
//   const profileUrl=`/summary/coapplicant?id=${Id}&status=In Disbursement`;
//   const digilockerUrl=`/digilocker/details?applicationId=${event.applicationId}&userId=${Id}`;
//   const panUrl=`/application/pan-details?userId=${Id}&applicationId=${event.applicationId}`;
//   const bankSelfieUrl=`/integrations/details?applicationId=${event.applicationId}&userId=${Id}`;
//   const uploadedFileUrl=`/users/documents/admin?userId=${Id}`
  const getActivityUrl=`/audit?applicationId=${event.applicationId}`
// const urlForBankSelfie=`/integrations/application-profile?applicationId=${event.applicationId}`
//   //cibil
//   const urlCIBIL = `/cibil/report?userId=${Id}`

//   const urlIncomeProfile=`/bank-statement-analysis/finbox/admin-analytics-data/all?userId=${Id}&applicationId=${event.applicationId}`
   
//     dispatch(userActions.getIncomeProfileAnalytics(urlIncomeProfile,user))
    
   
//   const getFoirRefUrl=`/admin/application/additional-info?applicationId=${event.applicationId}`
//   dispatch(userActions.getFoirDetails(getFoirRefUrl,user));
//         dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie,user),[])
//      dispatch(userActions.getCkycDetails(ckycUrl,user));
//     dispatch(userActions.getCibilDetails(urlCIBIL));
//     dispatch(userActions.getPanStatus(panUrl));
//     dispatch(userActions.getBankSelfieDetails(bankSelfieUrl,user));
//     dispatch(userActions.getDigiLocker(digilockerUrl,user));
//     dispatch(userActions.getProfileDetails(profileUrl));
//     dispatch(userActions.getUploadedFiles(uploadedFileUrl,user));
    dispatch(userActions.getActivity(getActivityUrl,user));
    navigate('/status/disbursement/profile', {
      state: { id: 1, profileId: Id,clickEvent:"coapp",applicantId:event.userId,coapplicantId:event.coapplicantId,applicationId:event.applicationId ,dir:"Ready to Disburse"},
    });

     
   
  };

  //Go To Application Profile
   const handleApplicationProfile=(currApplicationId,currUID,currCoAppId, item)=>{
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: { appId: currApplicationId, userId: currUID, coappId: currCoAppId } });
    const urlForApplicationDetails=`/admin/application/application-profile?applicationId=${currApplicationId}`
    const urlForBankSelfie=`/integrations/application-profile?applicationId=${currApplicationId}`
    const getEmiUrl=`/emis?applicationId=${currApplicationId}`
    const getActivityUrl=`/audit?applicationId=${currApplicationId}`
    dispatch(userActions.fetchUrlforApplicationdetails(urlForApplicationDetails,user),[])
    dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie,user),[])
    dispatch(userActions.fetchEmiUrl(getEmiUrl,user),[])
    dispatch(userActions.getActivity(getActivityUrl,user))
    navigate("/status/disbursement/appProfile", {state: item})
    
  }
  
  const handleDownloadList = () => {
    handleExcelDownload({
      status: status,
      instituteId: decode.instituteId ? decode.instituteId : id,
      fromDate: filterDateFrom,
      toDate: filterDateTo,
      productType:
        productTypeSelected && productTypeSelected !== "all"
          ? Number(productTypeSelected)
          : undefined,
      user: user,
      downloadIcon: download,
      buttonId: 'downloadButton',
      buttonStyles: {
        width: '90px',
        marginLeft: '120px'
      }
    });
  }   
  //payouts intergration
  const [selectedAlready,setSelectedAlready]=useState(true)
  // #1 get all selected
  const [selectedStatusOpen,setSelectedStatusOpen]=useState(false)
  const [selectedApp,setSelectedApp]=useState(null)
  const [displaySelected,setDisplaySelected]=useState(null)
  const [selectedName,setSelectedName]=useState(null)
  const [isLoadingDisbursement,setIsLoadingDisbursement]=useState(false)
  
  const handleSelectedApp=(event,item,index)=>{
    setSelectedName(item.name)
    if(event.target.checked===true )
    {
      setSelectedApp(item.applicationId)
      setSelectedAlready(!selectedAlready)
      setTimeout(() => {
        
        document.getElementById(`input${index}`).disabled=false
      }, 50);
      
    }
    else if(event.target.checked===false)
    {
     setSelectedApp(null)
     setSelectedAlready(!selectedAlready)
    }
  


  }

  const getInsituteInfo=(text)=>{
    
    const urlGetInstitute=`/institute/info/name?name=${text}`;
      
    if(text.length>=4)
    {
      axiosInstance.get(urlGetInstitute,{
        headers:{
        }
      }).then((res) => {
        setId(res?.data?.data[0]?.id)
        handleInputChange(res?.data?.data[0]?.id)
      });
  
   
    }
 
  }


  const handlepageChange = (number) => {

    setIsLoading(true)
    setActivePage(number)
    setrowsPerPage(number);

    let queryParams = {}
    
    if(filterDateFrom && filterDateTo){
      queryParams.fromDate = filterDateFrom;
      queryParams.toDate = filterDateTo+" 23:59:59"
    }
    
    if(id){
      queryParams.instituteId = id
    }
   
    if(status){
      queryParams.status = status
    }
  
   
    if(rowsPerPage && currentPage){
      queryParams.perPage = number;
      queryParams.pageNo = 1
    }

    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.productType = Number(productTypeSelected);
    }
    axiosInstance.get('/integrations/applications',{
      params:queryParams,
      headers: {
      },
    })
    .then((res)=>{    
      setTableData(res?.data?.data?.details);
      const amount = res?.data?.data?.details?.map((item) => (item?.amountToBeDisbursed - 
                    ((item?.advanceEmiStatus === 1) ? (item?.advanceEmiAmount || 0) : 0) - 
                    ((item?.processingFeeStatus === 1) ? (item?.processingFees || 0) : 0)));
        const totalAmount = amount?.reduce((sum, current) => sum + (current || 0), 0);
        setTotalAmountToBeDisbursed(totalAmount)
      setcurrentPage(res?.data?.data?.pagination?.currentPage);
      setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
      setrowsPerPage(res?.data?.data?.pagination?.perPage);
      setIsLoading(false);
    })
    .catch((error) => error)

};




  const handleInputChange = (id) => {
    let queryParams = {}
    
    if(filterDateFrom && filterDateTo){
      queryParams.fromDate = filterDateFrom;
      queryParams.toDate = filterDateTo+" 23:59:59"
    }
    
    if(id){
      queryParams.instituteId = id
    }
   
    if(status){
      queryParams.status = status
    }
  
   
    if(rowsPerPage && currentPage){
      queryParams.perPage = rowsPerPage;
      queryParams.pageNo = 1
    }

    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.productType = Number(productTypeSelected);
    }
    axiosInstance.get('/integrations/applications',{
      params:queryParams,
      headers: {
      },
    })
    .then((res)=>{    
      setTableData(res?.data?.data?.details);
      const amount = res?.data?.data?.details?.map((item) => (item?.amountToBeDisbursed - 
                    ((item?.advanceEmiStatus === 1) ? (item?.advanceEmiAmount || 0) : 0) - 
                    ((item?.processingFeeStatus === 1) ? (item?.processingFees || 0) : 0)));
        const totalAmount = amount?.reduce((sum, current) => sum + (current || 0), 0);
        setTotalAmountToBeDisbursed(totalAmount)
      setcurrentPage(res?.data?.data?.pagination?.currentPage);
      setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
      setrowsPerPage(res?.data?.data?.pagination?.perPage);
      setIsLoading(false);
    })
    .catch((error) => error)

};
   

  const handlePayouts=(createdList)=>{
    setIsLoadingDisbursement(true);
    const urlGetSelectedApp=`/disbursement/create`
    const data={
      applicationId:createdList
    }
    axiosInstance.post(urlGetSelectedApp,data,{
      headers:{
      }
    }).then((res)=>{
      setDisplaySelected(res.data.data)
      setSelectedStatusOpen(!selectedStatusOpen)
      setIsLoadingDisbursement(false);
    }).catch((error)=>{
      alert(error?.response?.data?.message);
      setIsLoadingDisbursement(false);
    })
  }


  function formatNumberWithCommas(number) {
    return number?.toLocaleString('en-IN');
  }
  const handleAccordionToggle = (event) => {
    event.stopPropagation(); 
    setExpanded((prev) => !prev);
  };



  if (tableData) {
    return (
      <Card  className="card" style={{width:"100%",height:'100%'}}>
        <CardBody>
        <div>
            <p style={{display:'flex',alignItems:'center'}}><img alt="" src={statusimage}/><span style={{fontFamily:'Inter-Medium',marginLeft:'10px',fontSize:'14px'}}>status</span><span style={{marginLeft:'20px',marginBottom:'3px'}}> <img style={{height:"18px",width:"14px"}} src={rightarrow} alt=""/></span><span style={{fontFamily:'Inter-Medium',marginLeft:'10px',fontSize:'14px',color:'#D32028'}}>In Disbursement</span>
            <span style={{fontFamily:'Inter-Medium',fontSize:'14px',color:"black",marginLeft:'25%'}}>Total Amount To Be Disbursed : <span style={{fontFamily:'Inter-Medium',marginLeft:'10px',fontSize:'14px',color:'#D32028'}}>{totalAmountToBeDisbursed ? <>&#8377;{formatNumberWithCommas(totalAmountToBeDisbursed)}</> : "₹ 0"}</span></span></p>
            
           </div>
          <Row>
            <div style={{ display: 'flex', flex: 'wrap' }}>
            <Col sm="12" md="10" lg="3">
            <div style={{ height: '23px',marginTop:'7px', marginRight: '10px',fontFamily:'Inter'  , position: 'relative', display: 'flex', alignItems: 'center' }}>
            {decode.role === "institute_admin" || decode.role === "institute_user" || decode.role === "institute_cra"?
            <Input
            type="text"
            id="userSearch"
            value={decode.instituteName}
            readOnly
            disabled
            placeholder={'Merchant Name'
            }
            style={{
               fontSize: '0.8vw',
              paddingLeft: '26px',
              fontFamily: 'Inter',
              backgroundImage: `url(${search})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '5px center',
              backgroundSize: '15px 15px',
              paddingRight: '5px', 
              borderColor:'#cccccc',
              borderStyle:'solid',
              borderRadius:"5px",
              borderWidth:'1px',
              height:'34px',
            }}
          />: 
        //   <Input
        //   type="text"
        //   id="userSearch"
        //   placeholder={ decode?.clientId==='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? 'Product Type': 'Merchant Name'}
        //   onChange={(event) => {
        //     getInsituteInfo(event.target.value);
        //   }}
        //   style={{
        //      fontSize: '0.8vw',
        //     paddingLeft: '26px',
        //     fontFamily: 'Inter',
        //     backgroundImage: `url(${search})`,
        //     backgroundRepeat: 'no-repeat',
        //     backgroundPosition: '5px center',
        //     backgroundSize: '15px 15px',
        //     paddingRight: '5px', 
        //     borderColor:'#cccccc',
        //     borderStyle:'solid',
        //     borderRadius:"5px",
        //     borderWidth:'1px',
        //     height:'34px',
        //   }}
        // />
          
           <InstituteAutocomplete
                key={instituteResetKey}
                        onInstituteSelect={(selectedId, name) => {
                          setId(selectedId)
                          setInstituteName(name||'')
                        }} 
                        defaultValue={instituteName}

                searchIcon={search}
                  placeholder={
                  decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
                    ? 'Product Type'
                    : 'Merchant Name'
                }
                marginTop={"12px"}
            />

          }
          </div>
            </Col>
              <Col>
              <div style={{ height: '7px',marginLeft:'10px', marginRight: '10px' }}>
                <Datetime
                closeOnSelect="false"
                  id="fromDate"
                  dateFormat="DD MMM YYYY"
                  timeFormat={false}
                  onChange={(event) =>{ 
                    if (event && event.format) {
                    setFilterDateFrom(event.format('DD MMM YYYY'));
                  }else{
                    setFilterDateFrom(null);
                  }
                  }}
                  locale="en-gb"
                  inputProps={{ placeholder: 'From Date',style:{fontFamily:'Inter',fontSize:"14px"} }}
                />
              </div>
            </Col>
            <Col>
              <div style={{ height: '7px', marginRight: '10px' }}>
                <Datetime
                closeOnSelect="false"
                  id="toDate"
                  dateFormat="DD MMM YYYY"
                  isValidDate={valid}
                  timeFormat={false}
                  locale="en-gb"
                  initialViewDate={
                        filterDateFrom
                          ? moment(filterDateFrom, 'DD MMM YYYY')
                          : moment()
                  }
                  onChange={(event) => {
                    if (event && event.format) {
                      setFilterDateTo(event.format('DD MMM YYYY'));
                    } else {
                      setFilterDateTo(''); 
                      clearDateFilter()
                    }
                  }}
                  value={filterDateTo ? moment(filterDateTo, 'DD MMM YYYY') : null}
                  inputProps={{ placeholder: 'To Date',style:{fontFamily:'Inter',fontSize:"14px"} }}
                />
              </div>
            </Col>

              <Col>
              <div> 
              <button style={{display:'flex',alignItems:'center',width:'130px',backgroundColor:'#D22129',height:'34px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter",paddingLeft:'10px'}}
                 onClick={() =>{handleInputChange(id);}}
                 
                >
                  Search Results
                </button>
                </div>
              </Col>
               <Col>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <button
                      onClick={() => clearDateFilter()}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '34px',
                        width: '42px',
                        backgroundColor: '#D22129',
                        border: 'none',
                        borderRadius: '5px',
                        color: 'white',
                        cursor: 'pointer',
                        marginLeft:'10px'
                      }}
                    >
                      <RefreshIcon />
                    </button>
                  </div>
                </Col>

              {decode.role!=="institute_user"&&decode.role!=="institute_admin"&& decode.role !== "channel_user" &&  decode?.clientId!=='98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'? <Col>
              <div style={{height:'34px',lineHeight:'33px',fontSize:'13px',fontFamily:"Inter",width:'200px',display:'flex',alignItems:'center'}}>
                <Button disabled={selectedApp!=null && !isLoadingDisbursement?false:true} onClick={() => handlePayouts(selectedApp)} color="primary" style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'8px'}}>
                  {isLoadingDisbursement ? <CircularProgress size={20} /> : 'Create Disbursement'}
                </Button></div>
              </Col>:null}

              {/* <Col>
              <div>
                <button style={{width:'100px',backgroundColor:'gray',height:'36.5px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter"}} onClick={() => handleClearFilter()} color="primary">
                  Clear Filter
                </button>
                </div>
              </Col> */}
              <Col>
              {(decode.role === "cra" || decode.role === "crsa" || decode.role === "institute_cra" ||
  (decode.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e" && decode.role === "institute_user")) ? "":(
                <Col>
            <button style={{backgroundColor:'#D22129',width:'90px',height:'34px',padding:'10px',display: 'flex', alignItems: 'center',marginLeft:"120px",borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter"}} id="downloadButton" onClick={() => handleDownloadList()}>
           <p style={{display:'flex',alignItems:'center',marginTop:'15px'}}><img style={{height:'15px',alignItems:"center",marginRight:'5px'}}  src={download} alt="download"/><span>Export</span></p> 
            </button>
            </Col>
              )}
              
              </Col>
            </div>
          </Row>
          <IntegrationModals ref={modalRef} user={user} decode={decode} onActionComplete={refreshTableData} />


         <DisbursementModal
        isOpen={selectedStatusOpen}
        onClose={() => setSelectedStatusOpen(false)}
        displaySelected={displaySelected}
        selectedName={selectedName}
        applicationId={displaySelected?.applicationId}
        user={user}
        onSuccess={() => window.location.reload(true)}
      />

      {isLoading ? (
         <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%',backgroundColor:'white',height:'100vh'}}>
         <CircularProgress />
       </Box>
      ):(
        <>
        <div className='tables' style={{ marginTop: '20px' }}>
            <table tyle={{ width: '100%', borderCollapse: 'collapse', borderSpacing: 0 }}>
              <thead className='table-heading'>
                <tr>
                  {decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user"? null: <th  id="select" style={{width:'5%',borderTopLeftRadius:'8px'}}><span style={{  fontSize: '14px',fontFamily: "Inter" ,marginLeft:'10px',whiteSpace:'nowrap',}}>Select</span></th>}
                  <th  id="appId" style={{width:'11%'}}><span style={{  fontSize: '14px',fontFamily: "Inter" ,marginLeft:'10px',whiteSpace:'nowrap',}}>Appl. Id</span> 
                  {/* <img style={{cursor:'pointer',width:'15px'}} src={Sort} alt="sort"/> */}
                  </th>
                  <th  id="appname" style={{width:'18%'}}><span style={{  fontSize: '14px',fontFamily: "Inter" ,marginLeft:'10px',whiteSpace:'nowrap'}}>Appl. Name</span> </th>
                  {(decode.role==="institute_user"||decode.role==="institute_admin"|| decode.role === "channel_user" ) && decode.instituteId === "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" ? 
                   <th  style={{  fontSize: '14px',fontFamily:"Inter",width:'10%' }} id="appname">
                   <span style={{marginLeft:'10px'}}></span> Student Name
                   </th>:null
                  }
                  <th  id="insName" style={{width:'17%'}}><span style={{  fontSize: '14px',fontFamily: "Inter" ,marginLeft:'10px',whiteSpace:'nowrap'}}>Merchant Name</span></th>
                  <th title='Digi Locker' style={{width:'5%'}}><span style={{fontFamily:'Inter',fontSize:'14px',marginLeft:'5px'}}><img src={kyc} alt="" style={{height:'30px',width:'30px'}}/></span></th>
                  <th title='selfie' id="selfie"style={{width:'5%'}}><span style={{fontFamily:'Inter',fontSize:'14px'}}><img src={selfie} alt="" style={{height:'30px',width:'30px'}}/></span></th>
                  {decode?.clientId==="98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" ? 
                  <>
                  <th title='mandate' id="eMandate"style={{width:'5%'}}><span style={{fontFamily:'Inter',fontSize:'14px',marginLeft:'5px'}}><img src={mandate} alt="" style={{height:'35px',width:'30px',paddingBottom:'5px'}}/></span></th>
                  <th title='agreement' id="agreement"style={{width:'5%'}}><span style={{fontFamily:'Inter',fontSize:'14px',marginLeft:'5px'}}><img src={agreement} alt=""  style={{height:'25px',width:'25px'}}/></span></th>
                  </> :
                  <>
                  <th title='agreement' id="agreement"style={{width:'5%'}}><span style={{fontFamily:'Inter',fontSize:'14px',marginLeft:'5px'}}><img src={agreement} alt=""  style={{height:'25px',width:'25px'}}/></span></th>
                  <th title='mandate' id="eMandate"style={{width:'5%'}}><span style={{fontFamily:'Inter',fontSize:'14px',marginLeft:'5px'}}><img src={mandate} alt="" style={{height:'35px',width:'30px',paddingBottom:'5px'}}/></span></th>
                  </>
                  }
                 {decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender" || decode.role === "channel_user" ? null :                  <th title='fraud detection' style={{width:'5%'}}><span style={{fontFamily:'Inter',fontSize:'14px',marginLeft:'5px'}}><img src={fraudimage} alt="" style={{height:'33px',width:'40px'}}/></span></th>
                }
                  <th  id="amt" style={{width:'8%'}}><span style={{  fontSize: '14px',fontFamily: "Inter" ,marginLeft:'10px'}}>Amount</span></th>
                  <th  id="tenure" style={{width:'5%'}}><span style={{  fontSize: '14px',fontFamily: "Inter" ,marginLeft:'10px'}}>Tenure</span></th>
                 
                  { decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender" || decode.role === "channel_user"?null:
                  <th id="fundSource" style={{width:'7%'}}><span style={{marginLeft:'10px',fontFamily:"Inter",whiteSpace:'nowrap', fontSize: '14px'}}>Pf Status</span></th>}
                  { decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender" || decode.role === "channel_user"?null:
                  <th id="actions"  style={{width:'5%',borderTopRightRadius:'8px'}} ><span style={{fontFamily:"Inter", fontSize: '14px'}}>Actions</span></th>}
                </tr>
              </thead>
              <tbody>
              {tableData.map((item, index) => {
                return (
                  <tr key={index}>
                    <td colSpan="100%" style={{ padding: 0 }}>
                      <CustomAccordion  style={{width: '100%', padding:0, cursor:'default !important', }} expanded={item?.coapplicants?.length===1 ? true: expanded}>
                        <CustomAccordionSummary sx={{ width: '100%', margin: 0, padding: 0 , display:'flex',flexDirection:'row', alignItems: 'center'}}
                           
                        >
                          {/* Input */}
                          {decode.role==="institute_user" || decode.role==="institute_admin" || decode.role === "channel_user"?
                          null:
                          <td style={{  width: '5%',paddingLeft:'10px', display:'flex',flexDirection:'row', alignItems: 'center',}}>
                            <input id={`input${index}`} disabled={!selectedAlready} style={{height:'18px',width:'18px'}} onChange={(e)=>handleSelectedApp(e,item,index)} type="checkbox"/>
                            </td>
                          }

                          {/* Appl. Id */}
                          <td  style={{ width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '14%':'11%', display:'flex',flexDirection:'row',justifyContent:'space-between', alignItems: 'center'}}>
                            <Tooltip title={item.applicationId} arrow>
                            <span onClick={()=>{
                              if(decode.role==="institute_user"||decode.role==="institute_admin"|| decode.role === "channel_user") return 
                              handleApplicationProfile(item.applicationId,item.userId,item.coapplicantId, item)}}
                               style={{display:'inline-block',whiteSpace:'nowrap',overflow:'hidden', cursor:'pointer', fontSize: '14px', fontWeight: '500', fontFamily:'Inter', maxWidth:'10em', lineHeight:'1.4em',color:'#667085', paddingLeft:'10px' }}>
                              {item.applicationId}
                            </span>
                            </Tooltip>
                            {item?.coapplicants?.length > 1 &&  <IconButton
                                onClick={handleAccordionToggle} 
                              >
                                {expanded ? <ExpandLessIcon />: <ExpandMoreIcon/>}
                            </IconButton>
                            }
                          </td>
                          {/* Applicant Name */}
                          <td title={item.name} onClick={() => {
                            if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")return
                            handleUser(item)
                          }
                          } className='rd-application-id'   style={{cursor:'pointer',lineHeight:'1.4em',color:'#667085', width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '23%':'18%'  }}>{item?.name?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</td>
                          {(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")&&decode.instituteId === "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" &&
                           <td title={item.studentName} className='rd-application-id' lassName='application-id' style={{width:'10%'}}>{item.studentName ? item.studentName : "-"}</td>
                           }
                           {/* MerchantName */}
                          <td style={{width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '21.5%':'17%',lineHeight:'1.4em',color:'#667085',}} className='rd-application-id'>
                            <span className="merchant-with-source">
                              <span title={item.instituteName}>{item.instituteName?item.instituteName:'-'}</span>
                              {item.productType === 2 && (
                                <SourceBadge attribution={item.attribution} repeat={item.repeat} />
                              )}
                            </span>
                            
                          </td>
                          {/* Digilocker */}
                          <td style={{width: decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '5.9%':'5%',  paddingLeft:'10px' }}>
                          <span style={{cursor:'pointer', fontSize:'12px', fontWeight:'bold', textAlign:'start'}}  onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")return;
                            if(item.digilockerStatus==="Pass"||item.digilockerStatus==="Alert")modalRef.current.open('digilocker',{applicationId:item.applicationId,userId:item.userId,name:item?.name||'',status:item.digilockerStatus})}}>
                            {item.digilockerStatus ? (
                            item.digilockerStatus === "Pass"  ? (
                              <div title='Pass' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>

                            ): item.digilockerStatus === "Alert"  ? (
                              <div title='Alert' style={{fontSize:'12px',backgroundColor:'orange',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>

                            ): item.digilockerStatus === "Initiated" ? (
                              <div title='Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>                   

                            ) :item.digilockerStatus === "Not Initiated" ? (
                              <div title='Not Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>                   

                            ) :
                             (
                              item.digilockerStatus
                            )
                          ) : (
                            <div style={{fontSize:'12px',fontWeight:'bold', textAlign:'start'}}>NA</div> )}
                          </span>
                          </td> 
                          {/* Selfie */}
                          <td  style={{width:decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '5.9%':'5%' , paddingLeft:'10px'}}>
                            <span  onClick={ ()=>{if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")return;
                             modalRef.current.open('selfie',{applicationId:item.applicationId,userId:item.userId})}} style={{cursor:'pointer', fontSize:'12px', fontWeight:'bold'}}
                              >
                              {item.selfie?
                              (item.selfie==="Pass"?<div title='Pass' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                              :item.selfie==="Not Initiated"?<div title='Not Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>                   
                              :item.selfie==="Initiated"?<div title='Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>                   
                              :item.selfie==="Face mismatch"?<div title='Attn! Face mismatch' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                              :item.selfie):
                              <div style={{fontSize:'12px',fontWeight:'bold'}}>NA</div>}
                           </span>
                          </td>
                        {decode?.clientId==="98ffb18a-9fee-43a5-91a3-4b2b9d9ae361" ?
                          <>
                           {/* EMandate */}
                        <td  style={{width:decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '6.5%':'5%'  , paddingLeft:'10px'}}>
                            <span id="emandate" onClick={()=>{
                              if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")return;
                              modalRef.current.open('mandate',{applicationId:item.applicationId,userId:item.userId,name:item.name,status:item.emandate,cra:item.cra})
                                }} style={{  cursor:'pointer', fontSize:'12px', fontWeight:'bold'}}>
                                {item.emandate?
                                  (item.emandate==="Rejected"?<div title='Rejected' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}></div>
                                  :item.emandate==="Pass"?<div title='Pass' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.emandate==="Upi Mandate Done"?<div title='Upi Mandate Done' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                  :item.emandate==="Upi Mandate Failed"?<div title='Upi Mandate Failed' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                  :item.emandate==="Upi Mandate Initiated"?<div title='Upi Mandate Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                  :item.emandate==="Upi Mandate Partial"?<div title='Upi Mandate Partial' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                  :item.emandate==="Initiated"?<div title='Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.emandate==="Not Initiated"?<div title='Not Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.emandate==="Invalid Bank Details"?<div title='Invalid Bank Details' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.emandate==="Aadhaar Mandate Initiated"?<div title='Aadhaar Mandate Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}> A</div>
                                  :item.emandate==="Aadhaar Mandate Done"?<div title='Aadhaar Mandate Done' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>A</div>
                                  :item.emandate==="Aadhaar Mandate Failed"?<div title='Aadhaar Mandate Failed' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}> A</div>
                                  :item.emandate==="Aadhaar Mandate ToDo"?<div title='Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>A</div>
                                  :item.emandate==="Upi Mandate ToDo"?<div title='Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                  :item.emandate==="Not Applicable"?<div title='Not Applicable' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.emandate):<div style={{fontSize:'12px',fontWeight:'bold'}}>NA</div>}
                            </span>
                        </td>
                          {/* Aggrement */}
                          <td  style={{width:decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '6.9%':'5%' , paddingLeft:'10px'}}>
                            <span onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")return;
                              modalRef.current.open('agreement',{applicationId:item.applicationId,userId:item.userId,status:item.agreement})}} style={{cursor:'pointer', fontSize:'12px', fontWeight:'bold'}}>
                              {item.agreement?
                                  (
                                  item.agreement==="Signed"?<div title='Signed' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.agreement==="Invalid"?<div title='Attn!' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.agreement==="Regenerated"?<div title='Regenerated' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.agreement==="Pending"?<div title='Pending' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.agreement==="Manual"?<div title='Manual' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>M</div>
                                  :item.agreement==="Not Initiated"?<div title='Not Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>                   
                                  :item.agreement):<div style={{fontSize:'12px',fontWeight:'bold'}}>NA</div>}
                            </span>
                        </td>
                       
                          </>:
                          <>
                          {/* Aggrement */}
                          <td  style={{width:decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '6.9%':'5%' , paddingLeft:'10px'}}>
                            <span onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")return;
                              modalRef.current.open('agreement',{applicationId:item.applicationId,userId:item.userId,status:item.agreement})}} style={{cursor:'pointer', fontSize:'12px', fontWeight:'bold'}}>
                              {item.agreement?
                                  (
                                  item.agreement==="Signed"?<div title='Signed' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.agreement==="Invalid"?<div title='Attn!' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.agreement==="Regenerated"?<div title='Regenerated' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.agreement==="Pending"?<div title='Pending' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.agreement==="Manual"?<div title='Manual' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>M</div>
                                  :item.agreement==="Not Initiated"?<div title='Not Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.agreement):<div style={{fontSize:'12px',fontWeight:'bold'}}>NA</div>}
                            </span>
                        </td>
                        {/* EMandate */}
                        <td  style={{width:decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '6.5%':'5%'  , paddingLeft:'10px'}}>
                            <span id="emandate" onClick={()=>{
                              if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")return;
                              modalRef.current.open('mandate',{applicationId:item.applicationId,userId:item.userId,name:item.name,status:item.emandate,cra:item.cra})
                                }} style={{  cursor:'pointer', fontSize:'12px', fontWeight:'bold'}}>
                                {item.emandate?
                                  (item.emandate==="Rejected"?<div title='Rejected' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}></div>
                                  :item.emandate==="Pass"?<div title='Pass' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.emandate==="Upi Mandate Done"?<div title='Upi Mandate Done' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                  :item.emandate==="Upi Mandate Failed"?<div title='Upi Mandate Failed' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                  :item.emandate==="Upi Mandate Initiated"?<div title='Upi Mandate Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                  :item.emandate==="Upi Mandate Partial"?<div title='Upi Mandate Partial' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                  :item.emandate==="Initiated"?<div title='Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.emandate==="Not Initiated"?<div title='Not Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.emandate==="Invalid Bank Details"?<div title='Invalid Bank Details' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.emandate==="Emandate Auth Success"?<div title='Pending' style={{fontSize:'12px',backgroundColor:'#F8A31F',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.emandate==="Aadhaar Mandate Initiated"?<div title='Aadhaar Mandate Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}> A</div>
                                  :item.emandate==="Aadhaar Mandate Done"?<div title='Aadhaar Mandate Done' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>A</div>
                                  :item.emandate==="Aadhaar Mandate Failed"?<div title='Aadhaar Mandate Failed' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}> A</div>
                                  :item.emandate==="Aadhaar Mandate ToDo"?<div title='Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>A</div>
                                  :item.emandate==="Upi Mandate ToDo"?<div title='Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                  :item.emandate==="Not Applicable"?<div title='Not Applicable' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :item.emandate):<div style={{fontSize:'12px',fontWeight:'bold'}}>NA</div>}    
                            </span>
                        </td>
                         </>
                        }
                        {/* Fraud */}
                        {decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user"?null:(
                        <td  style={{width:decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '5.9%':'5%',  paddingLeft:'10px'}}>
                        <span  onClick={()=> {
                            if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")return;
                            modalRef.current.open('fraud',{applicationId:item.applicationId,userId:item.userId,name:item.name})
                            }} style={{cursor:'pointer', display:'flex', alignItems:'center', }}>
                          {item.applicantFraudCheck?
                          (item.applicantFraudCheck==="fail"?<div title='fail' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                          :item.applicantFraudCheck==="pass"?<div title='pass' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                          :item.applicantFraudCheck):<div style={{fontSize:'12px',fontWeight:'bold'}}>NA</div>}
                          </span>
                      </td> 
                        )}
                       
                        <td style={{  fontSize: '14px', width:decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '10%': "8%" , color: '#667085',fontFamily:"Inter",paddingLeft:'10px' }}>{item.amount ? ( <>&#8377;{formatNumberWithCommas(item.amount)}</>) : ( '-')}</td>
                        <td style={{  fontSize: '14px', width:decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user" ? '5.9%': '5%', paddingLeft:'10px', color: '#667085',fontFamily:"Inter"  }}>{item.tenure?item.tenure:'-'} </td>   
                        {decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender"  || decode.role === "channel_user" ? null :
                        <td style={{  color: '#667085',fontSize: '14px' ,fontFamily:"Inter", width:'3%',display:'flex', paddingLeft:'7px',  justifyContent:'center'}}>
                          
                         </td>}                     
                        { decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender"|| decode.role === "channel_user"?null:
                        <td style={{  fontSize: '14px', width: '7%', paddingLeft:'10px', color: '#667085',fontFamily:"Inter"   }}>
                          {item?.paymentStatus ?
                          (
                            item?.paymentStatus === "Link Generated"?<div title='Link Generated' style={{fontSize:'12px',backgroundColor:'#F8A31F',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px', }}></div>
                            :item?.paymentStatus === "Failed"?<div title='Failed' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                            :item?.paymentStatus === "Paid"?<div title='Paid' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                            :item?.paymentStatus === "Not Applicable"?<div title='Not Applicable' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',fontWeight:'700',display:'flex',justifyContent:'center',alignItems:'center',color:'black'}}>NA</div>
                            :item?.paymentStatus === "Paid At Institute"?<div title='Paid At Institute' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',fontWeight:'700',display:'flex',justifyContent:'center',alignItems:'center',color:'black'}}>I</div>
                            :item?.paymentStatus
                          )
                          :"NA"}
                        </td>}
                       { decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender"|| decode.role === "channel_user" || decode.role === "exec"?null:
                        <td style={{width:'4%', paddingLeft:'10px'}}>
                        
                            <span title='Move Status' ><MoveDisbursementStatus    ApplicantId={item} /></span>

                         
                        </td>}

                        </CustomAccordionSummary>
                        {
                          item?.coapplicants?.map((coapp, index)=> (
                            <CustomAccordionSummary key={index} sx={{ width: '100%',  margin: 0, padding: 0 , display:'flex',flexDirection:'row', alignItems:'start', }}
                           
                            >
                              {/* Input */}
                              {decode.role==="institute_user" || decode.role==="institute_admin" || decode.role === "channel_user"?null:
                              <td style={{  width: '5%',paddingLeft:'10px', display:'flex',flexDirection:'row', alignItems: 'center'}}>
                                </td>
                              }

                              {/* Appl. Id */}
                              <td  style={{ width:'11%', display:'flex',flexDirection:'row',justifyContent:'space-between', alignItems: 'center',}}>
                              
                              </td>
                              {/* Applicant Name */}
                              <td title={coapp.coapplicantName} onClick={() => {if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user") return
                                  handleCoApp(item)}} className='rd-application-id'   style={{cursor:'pointer', width:'18%' ,color:'#667085' }}>{coapp?.coapplicantName?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}(C)</td>
                              {(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")&&decode.instituteId === "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" &&
                              <td title={item.studentName} className='rd-application-id' lassName='application-id' style={{width:'10%'}}>{item.studentName ? item.studentName : "-"}</td>
                              }
                              {/* MerchantName */}
                              <td style={{width:'17%'}} className='rd-application-id'>
                                
                              </td>
                              {/* Digilocker */}
                              <td style={{width:'5%',  paddingLeft:'10px' }}>
                              <span style={{cursor:'pointer', fontSize:'12px', fontWeight:'bold', textAlign:'start'}}  onClick={()=>{ if(decode.role==="institute_user"||decode.role==="institute_admin"|| decode.role === "channel_user") return;
                                if(coapp.coapplicantDigilockerStatus==="Pass"||coapp.coapplicantDigilockerStatus==="Alert")modalRef.current.open('digilocker',{applicationId:item.applicationId,userId:coapp.coapplicantId,name:coapp?.coapplicantName||'',status:coapp.coapplicantDigilockerStatus})}}>
                                {coapp.coapplicantDigilockerStatus ? (
                                coapp.coapplicantDigilockerStatus === "Pass"  ? (
                                  <div title='Pass' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>

                                ): coapp.coapplicantDigilockerStatus === "Alert"  ? (
                                  <div title='Alert' style={{fontSize:'12px',backgroundColor:'orange',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
    
                                ): coapp.coapplicantDigilockerStatus === "Initiated" ? (
                                  <div title='Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>                   

                                ) :coapp.coapplicantDigilockerStatus === "Not Initiated" ? (
                                  <div title='Not Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>                   

                                ) :
                                (
                                  coapp.coapplicantDigilockerStatus
                                )
                              ) : (
                                <div style={{fontSize:'12px',fontWeight:'bold', textAlign:'start'}}>NA</div> )}
                              </span>
                              </td> 
                              {/* Selfie */}
                              <td  style={{width:'5%' , paddingLeft:'10px'}}>
                                <span  onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin"|| decode.role === "channel_user") return;
                                  modalRef.current.open('selfie',{applicationId:item.applicationId,userId:coapp.coapplicantId})}} style={{cursor:'pointer', fontSize:'12px', fontWeight:'bold'}}
                                  >
                                  {coapp.coapplicantSelfie?
                                  (coapp.coapplicantSelfie==="Pass"?<div title='Pass' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :coapp.coapplicantSelfie==="Not Initiated"?<div title='Not Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>                   
                                  :coapp.coapplicantSelfie==="Initiated"?<div title='Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>                   
                                  :coapp.coapplicantSelfie==="Face mismatch"?<div title='Attn! Face mismatch' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                  :coapp.coapplicantSelfie):
                                  <div style={{fontSize:'12px',fontWeight:'bold'}}>NA</div>}
                              </span>
                              </td>
                              
                              {/* Aggrement */}
                              <td  style={{width:'5%' , paddingLeft:'10px'}}>
                                <span onClick={()=>{if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")return;
                                  modalRef.current.open('agreement',{applicationId:item.applicationId,userId:coapp.coapplicantId,status:coapp.coapplicantAgreement})}} style={{cursor:'pointer', fontSize:'12px', fontWeight:'bold'}}>
                                  {coapp.coapplicantAgreement?
                                      (
                                      coapp.coapplicantAgreement==="Signed"?<div title='Signed' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                      :coapp.coapplicantAgreement==="Invalid"?<div title='Attn!' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                      :coapp.coapplicantAgreement==="Regenerated"?<div title='Regenerated' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                      :coapp.coapplicantAgreement==="Pending"?<div title='Pending' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                      :coapp.coapplicantAgreement==="Manual"?<div title='Manual' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>M</div>
                                      :coapp.coapplicantAgreement==="Not Initiated"?<div title='Not Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>                   
                                      :coapp.coapplicantAgreement):<div style={{fontSize:'12px',fontWeight:'bold'}}>NA</div>}
                                </span>
                            </td>
                            {/* EMandate */}
                            <td  style={{width:'5%'  , paddingLeft:'10px'}}>
                                <span id="emandate" onClick={()=>{
                                  if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")return;
                                  modalRef.current.open('mandate',{applicationId:item.applicationId,userId:coapp.coapplicantId,name:coapp.coapplicantName,status:coapp.coapplicantEmandate,cra:item.cra})
                                    }} style={{  cursor:'pointer', fontSize:'12px', fontWeight:'bold'}}>
                                    {coapp.coapplicantEmandate?
                                      (coapp.coapplicantEmandate==="Rejected"?<div title='Rejected' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}></div>
                                      :coapp.coapplicantEmandate==="Pass"?<div title='Pass' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                      :coapp.coapplicantEmandate==="Upi Mandate Done"?<div title='Upi Mandate Done' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                      :coapp.coapplicantEmandate==="Upi Mandate Failed"?<div title='Upi Mandate Failed' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                      :coapp.coapplicantEmandate==="Upi Mandate Initiated"?<div title='Upi Mandate Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                      :coapp.coapplicantEmandate==="Upi Mandate Partial"?<div title='Upi Mandate Partial' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                      :coapp.coapplicantEmandate==="Initiated"?<div title='Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                      :coapp.coapplicantEmandate==="Not Initiated"?<div title='Not Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                      :coapp.coapplicantEmandate==="Invalid Bank Details"?<div title='Invalid Bank Details' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                      :coapp.coapplicantEmandate==="Emandate Auth Success"?<div title='Pending' style={{fontSize:'12px',backgroundColor:'#F8A31F',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                      :coapp.coapplicantEmandate==="Aadhaar Mandate Initiated"?<div title='Aadhaar Mandate Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}> A</div>
                                      :coapp.coapplicantEmandate==="Aadhaar Mandate Done"?<div title='Aadhaar Mandate Done' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>A</div>
                                      :coapp.coapplicantEmandate==="Aadhaar Mandate Failed"?<div title='Aadhaar Mandate Failed' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}> A</div>
                                      :coapp.coapplicantEmandate==="Aadhaar Mandate ToDo"?<div title='Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>A</div>
                                      :coapp.coapplicantEmandate==="Upi Mandate ToDo"?<div title='Initiated' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}>U</div>
                                      :coapp.coapplicantEmandate==="Not Applicable"?<div title='Not Applicable' style={{fontSize:'12px',backgroundColor:'#898989',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px',display:'flex',alignItems:'center',textAlign:'center',justifyContent:'center',fontWeight:'bold',cursor:'pointer'}}></div>
                                      :coapp.coapplicantEmandate):<div style={{fontSize:'12px',fontWeight:'bold'}}>NA</div>}    
                                </span>
                            </td>
                            {/* Fraud */}
                            {(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")?null:(
                              <td  style={{width:'5%',  paddingLeft:'10px'}}>
                              <span  onClick={()=> {
                                  if(decode.role==="institute_user"||decode.role==="institute_admin" || decode.role === "channel_user")return;
                                  modalRef.current.open('fraud',{applicationId:item.applicationId,userId:coapp.coapplicantId,name:item.name})
                                  }} style={{cursor:'pointer', display:'flex', alignItems:'center', }}>
                                {coapp.coapplicantFraudCheck?
                                (coapp.coapplicantFraudCheck==="fail"?<div title='fail' style={{fontSize:'12px',backgroundColor:'#D22129',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                :coapp.coapplicantFraudCheck==="pass"?<div title='pass' style={{fontSize:'12px',backgroundColor:'#12B76A',borderStyle:'solid',borderRadius:'50%',border:'none',height:'20px',width:'20px'}}></div>
                                :coapp.coapplicantFraudCheck):<div style={{fontSize:'12px',fontWeight:'bold'}}>NA</div>}
                                </span>
                            </td>  
                            )}
                            
                            <td style={{  fontSize: '14px', width: "8%" , color: '#667085',fontFamily:"Inter",paddingLeft:'10px' }}></td>
                            <td style={{  fontSize: '14px', width: '5%', paddingLeft:'10px', color: '#667085',fontFamily:"Inter"  }}></td>   
                            {decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender"  || decode.role === "channel_user" ? null :
                        <td style={{  color: '#667085',fontSize: '14px' ,fontFamily:"Inter", width:'3%',display:'flex', paddingLeft:'7px',  justifyContent:'center'}}>
                          
                         </td>}                     
                            { decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender"|| decode.role === "channel_user"?null:
                            <td style={{  fontSize: '14px', width: '7%', paddingLeft:'10px', color: '#667085',fontFamily:"Inter"   }}>
                              
                            </td>}
                          { decode.role==="institute_user"||decode.role==="institute_admin"||decode.role==="user"||decode.role==="co_lender"|| decode.role === "channel_user"?null:
                            <td style={{width:'4%', paddingLeft:'10px'}}>
                
                            </td>}

                        </CustomAccordionSummary>
                          ))
                        }
                      
                      </CustomAccordion>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            </table>
            </div>
            {totalFetchRows ? ( totalFetchRows <= 100 ?(
                    <div style={{display:"flex" ,justifyContent:"center",marginTop:"10px"}}>
                      <div style={{ textAlign: 'center', fontWeight: 'bold',fontFamily:"Inter", fontSize: '1vw',marginLeft:'10px',marginBottom:'5px' }}>
               
               Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage - rowsPerPage+tableData?.length}{" "}
                records of {totalFetchRows} |
               
             </div>
            <div style={{display:"flex", justifyContent:"space-between",}}>
            &nbsp;<p style={{fontWeight:'600'}}>Rows Per Pages :</p>
          <div>
          <span onClick={()=>handlepageChange(15)} style={{cursor:'pointer',padding:'10px',color: activePage === 15 ? "#D32028" : "black",backgroundColor:activePage === 15 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>15</span>
          <span onClick={()=>handlepageChange(50)} style={{cursor:'pointer',padding:'10px',color: activePage === 50 ? "#D32028" : "black",backgroundColor:activePage === 50 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>50</span>
          <span onClick={()=>handlepageChange(100)} style={{cursor:'pointer',padding:'10px',color: activePage === 100 ? "#D32028" : "black",backgroundColor:activePage === 100 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>100</span>
          <span onClick={()=>handlepageChange(500)} style={{cursor:'pointer',padding:'10px',color: activePage === 500 ? "#D32028" : "black",backgroundColor:activePage === 500 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>500</span>
          </div>
         
         
          </div>
                      
                    </div>
               
            ):( <div style={{display:"flex",justifyContent:"center",marginTop:"10px"}}><div style={{ textAlign: 'center',fontWeight: 'bold',justifyContent:"space-between",fontFamily:"Inter-Medium", fontSize: '1vw',marginLeft:'10px',marginBottom:'5px',marginRight:'10px'}}>
                
            Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage - rowsPerPage+tableData?.length} {" "}
            records of {totalFetchRows} |
           
          </div>
          <div style={{display:"flex", justifyContent:"space-between",}}>
            <p style={{fontWeight:'600'}}>Rows Per Pages :</p>
          <div>
          <span onClick={()=>handlepageChange(15)} style={{cursor:'pointer',padding:'10px',color: activePage === 15 ? "#D32028" : "black",backgroundColor:activePage === 15 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>15</span>
          <span onClick={()=>handlepageChange(50)} style={{cursor:'pointer',padding:'10px',color: activePage === 50 ? "#D32028" : "black",backgroundColor:activePage === 50 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>50</span>
          <span onClick={()=>handlepageChange(100)} style={{cursor:'pointer',padding:'10px',color: activePage === 100 ? "#D32028" : "black",backgroundColor:activePage === 100 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>100</span>
          <span onClick={()=>handlepageChange(500)} style={{cursor:'pointer',padding:'10px',color: activePage === 500 ? "#D32028" : "black",backgroundColor:activePage === 500 ?"#FFF2F3" : "" ,borderRadius:'8px'}}>500</span>
          </div>
          </div>
          </div> )
             
            ) : (
              <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily:"Inter", fontSize: '14px' }}>No Records</div>
            )}

            <PaginationTable
              startPage={currentPage}
              rowsPerPage={rowsPerPage}
              totalRows={totalFetchRows}
              paginate={paginate}
              filterDateFrom={filterDateFrom}
            />
        </>
      )}
          
         
        </CardBody>
      </Card>
    );
  }
  return <div>....Loading</div>;
};

export default InDisbursement;
